import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';

import './ab-test-admin-ui.scss';

const AbTestAdminUi = ({ abTests }) => {
  const [collapsed, setCollapsed] = useState(
    typeof window !== 'undefined'
      ? window.localStorage.getItem('abTestAdmin-collapsed') === '1'
      : false
  );
  const [currentY, setCurrentY] = useState(0);

  useEffect(() => {
    const handleScroll = throttle(() => {
      const thisY = window.pageYOffset;
      setCurrentY(thisY);
    }, 200);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleAbtestAdmin = () => {
    window.localStorage.setItem(
      'abTestAdmin-collapsed',
      !collapsed ? '1' : '0'
    );

    setCollapsed(!collapsed);
  };

  const numTests = Object.keys(abTests).length;

  return (
    <div
      className={`ab-test-admin-ui ${
        collapsed ? 'ab-test-admin-ui--collapsed' : ''
      }`}
    >
      <button
        type="button"
        className="ab-test-admin-ui__title"
        onClick={() => toggleAbtestAdmin()}
      >
        {`${numTests} AB Test${numTests === 1 ? '' : 's'} on this Page`}
      </button>
      {Object.entries(abTests).map(
        ([
          test,
          { branches, branch, trigger, triggerFired, distance, updateBranch }
        ]) => (
          <div key={test} className="ab-test-admin-ui__test-wrapper">
            <p className="ab-test-admin-ui__header">{test}</p>
            <p
              className={`ab-test-admin-ui__trigger ${
                triggerFired ? 'ab-test-admin-ui__trigger--fired' : ''
              }`}
            >
              {`${triggerFired ? 'Was assigned' : 'Will assign'} on ${trigger}`}
              {trigger === 'scroll' ? ` (${distance}px)` : ''}
            </p>
            <form>
              {Object.keys(branches)
                .filter(curBranch => branches[curBranch] !== null)
                .map(curBranch => (
                  <label
                    key={`${test}|${curBranch}`}
                    className={`ab-test-admin-ui__edit-button ${
                      curBranch === branch
                        ? 'ab-test-admin-ui__edit-button--active'
                        : ''
                    }`}
                  >
                    <input
                      type="radio"
                      name={test}
                      onChange={() => {
                        const storageKey = `abTest_${test}`;
                        if (curBranch) {
                          window.localStorage.setItem(storageKey, curBranch);
                        }
                        updateBranch(curBranch);
                      }}
                      checked={curBranch === branch}
                    />
                    {`${curBranch.replace(/_/g, '-')}: ${branches[curBranch]}`}
                  </label>
                ))}
            </form>
          </div>
        )
      )}
      <p className="ab-test-admin-ui__scroll-depth">
        {`Scroll Depth: ${currentY}`}
      </p>
    </div>
  );
};

AbTestAdminUi.propTypes = {
  abTests: PropTypes.shape({}).isRequired
};

export default AbTestAdminUi;
